import { MarkerClusterer } from '@googlemaps/markerclusterer';

export const PXMap = (function () {
	'use strict';

	let $locationsList,
		$locationsSearchForm,
		$locationSearchInput,
		$errorMsg,
		$locationsCounter,
		locations,
		map,
		initLat,
		initLng;

	// const computeDistanceBetween = (x1, y1, x2, y2, rad = 6378000) => {
	// 	x1 = parseFloat(x1);
	// 	x2 = parseFloat(x2);
	// 	y1 = parseFloat(y1);
	// 	y1 = parseFloat(y2);

	// 	const x_diff = x2 - x1;
	// 	const y_diff = y2 - y1;
	// 	const sin2 = (x) => {
	// 		return Math.pow(Math.sin(x), 2);
	// 	};

	// 	let a = sin2(x_diff.toRad() / 2) + Math.cos(x1.toRad()) * Math.cos(x2.toRad()) * sin2(y_diff.toRad() / 2);

	// 	a = 2 * rad * Math.asin(Math.sqrt(a));

	// 	return a;
	// };

	const calculateDistances = (origin) => {
		locations.forEach((location) => {
			let latLng1 = new google.maps.LatLng(origin.lat, origin.lng);
			let latLng2 = new google.maps.LatLng(location['lat'], location['lng']);

			const distanceInMiles = (
				google.maps.geometry.spherical.computeDistanceBetween(latLng1, latLng2) / 1609
			) // convert meters to miles
				.toFixed(2);

			location['distanceFromCenter'] = +distanceInMiles;
		});

		locations.sort((a, b) => {
			if (a.distanceFromCenter === b.distanceFromCenter) return 0;
			return a.distanceFromCenter < b.distanceFromCenter ? -1 : 1;
		});
	};

	function init() {
		console.log('map init!');
		$locationsList = $('#wtb-locations');
		$locationsSearchForm = $('.locations-search-form');
		$locationSearchInput = $('#locations-search-input');
		$errorMsg = $('.error-msg');
		$locationsCounter = $('.locations-counter');
		initLat = 33.5186;
		initLng = -86.8104;

		if ($('.pxblock--map').length && typeof wtb_locations_json !== 'undefined') {
			initMap();
			initSearch();
			checkForAddressQuery();

			if (
				document.getElementById('map').dataset.lat &&
				document.getElementById('map').dataset.lng
			) {
				let lat = document.getElementById('map').dataset.lat;
				let lng = document.getElementById('map').dataset.lng;
				map.setCenter(new google.maps.LatLng(parseFloat(lat), parseFloat(lng)));
				updateLocationInfoBoxes();
			} else if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(setUserLocation);
			}
		}
	}

	function setUserLocation(location) {
		initLat = location.coords.latitude;
		initLng = location.coords.longitude;
		map.setCenter(new google.maps.LatLng(initLat, initLng));
		updateLocationInfoBoxes();
	}

	function initMap() {
		locations = wtb_locations_json;

		map = new google.maps.Map(document.getElementById('map'), {
			zoom: 8,
			minZoom: 8,
			maxZoom: 12,
			center: new google.maps.LatLng(initLat, initLng),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: true,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
		});

		const mapCenter = { lat: map.getCenter().lat(), lng: map.getCenter().lng() };

		calculateDistances(mapCenter);

		const markers = locations.map((location, i) => {
			let marker = new google.maps.Marker({
				position: new google.maps.LatLng(location['lat'], location['lng']),
				map: map,
			});

			let infoWindowHtml = `${location['name']}<br>${location['address']}<br>${location['city']}, ${location['state']} ${location['zip']}`;

			let infoWindow = new google.maps.InfoWindow({
				content: infoWindowHtml,
			});

			marker.addListener('click', () => {
				infoWindow.setContent(infoWindowHtml);
				infoWindow.open(map, marker);
			});

			return marker;
		});

		const markerCluster = new MarkerClusterer({ map, markers });

		google.maps.event.addListenerOnce(map, 'idle', function () {
			const url = new URL(window.location.href);
			const urlParams = new URLSearchParams(url.search);
			const searchLocationsParam = urlParams.get('search_locations');

			if (searchLocationsParam) {
				submitSearch(searchLocationsParam);
			} else {
				updateLocationInfoBoxes();
			}
		});

		google.maps.event.addListener(map, 'dragend', function () {
			updateLocationInfoBoxes();
		});

		google.maps.event.addListener(map, 'zoom_changed', function () {
			updateLocationInfoBoxes();
		});
	}

	function addLocationInfoBox(location) {
		let location_directions_link = `https://www.google.com/maps/dir//${location['lat']},${location['lng']}`;

		if (location['cta_url'] && locations.length == 1) {
			location_directions_link = location['cta_url'].replaceAll('\\', '').replaceAll("'", '');
		}

		let $locationInfoBox = `
			<li id='location-${location['id']}' class='location'>
				<a href='${location_directions_link}' aria-label='Get Directions to ${location['name']}'>
					<p>${location['name']}</p>
					<span class='location--address'>${location['address']}</span>
					<span class='location--csz'>${location['city']}, ${location['state']} ${location['zip']}</span>
				</a>
				<a href='tel:${location['phone']}' aria-label='Call ${location['name']}'><span class='location--phone'>${location['phone']}</span></a>
				<div class='location--btns'>
					<a href='${location_directions_link}' aria-label='Get Directions to ${location['name']}' class='btn'>Get Directions</a>
				</div>
			</li>
		`;

		// <a href='${location['website']}' class='location--website' aria-label='Visit ${location['name']} Website'>Visit Website</a>

		$locationsList.append($locationInfoBox);
	}

	function updateLocationInfoBoxes() {
		let totalLocaitons = 0;
		const bounds = map.getBounds();

		if (!bounds) return;

		const sw = bounds.getSouthWest().toJSON();
		const ne = bounds.getNorthEast().toJSON();
		const mapCenter = { lat: map.getCenter().lat(), lng: map.getCenter().lng() };
		const listContainer = $locationsList[0];

		calculateDistances(mapCenter);

		console.log('*** UPDATE LOCATIONS ***', locations[0], ne, sw);

		while (listContainer.firstChild) listContainer.removeChild(listContainer.firstChild);

		locations.forEach((location, i) => {
			if (
				location['lat'] < ne['lat'] &&
				location['lat'] > sw['lat'] &&
				location['lng'] < ne['lng'] &&
				location['lng'] > sw['lng']
			) {
				console.log(
					location.distanceFromCenter,
					location.name,
					location.address,
					location.city,
					location.state
				);
				addLocationInfoBox(location);
				totalLocaitons++;
			}
		});

		$locationsCounter.find('span').html(totalLocaitons);
	}

	function initSearch() {
		$locationsSearchForm.submit((e) => {
			e.preventDefault();
			submitSearch();
		});
	}

	function submitSearch(address = $locationSearchInput.val()) {
		let geocoder = new google.maps.Geocoder();

		geocoder.geocode({ address: address }, function (results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				$errorMsg.hide();
				$locationsCounter.show();
				let lat = results[0].geometry.location.lat();
				let lng = results[0].geometry.location.lng();
				let center = new google.maps.LatLng(lat, lng);
				map.panTo(center);
				updateLocationInfoBoxes();
			} else {
				$errorMsg.show();
				$locationsCounter.hide();
				// console.log('Geocode was not successful for the following reason: ' + status);
			}
		});
	}

	function checkForAddressQuery() {
		if (window.location.search) {
			let urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('address')) {
				let queryAddress = urlParams.get('address');

				$locationSearchInput.val(queryAddress);
				submitSearch();
			}
		}
	}

	return {
		init: init,
	};
})();
